import { copy } from "shared/assets";
import { IActionDropdownItem } from "shared/components";
import { IStatus } from "shared/types";

const {
  members: { sentInvitationsTable: tableCopy },
} = copy;

export const getSentInvitationsActions = ({
  handleResend,
  handleRevoke,
  handleEdit,
  handleEditPermissions,
  handleDelete,
}: {
  handleResend: () => void;
  handleRevoke: () => void;
  handleEdit: () => void;
  handleEditPermissions: () => void;
  handleDelete: () => void;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [
    {
      label: tableCopy.actions.resend,
      handleClick: handleResend,
      dataTestId: "resend_invitation_action",
    },
    {
      label: tableCopy.actions.revoke,
      handleClick: handleRevoke,
      dataTestId: "revoke_invitation_action",
    },
    {
      label: tableCopy.actions.edit,
      handleClick: handleEdit,
      dataTestId: "edit_invitation_action",
    },
    {
      label: tableCopy.actions.permissions,
      handleClick: handleEditPermissions,
      dataTestId: "edit_permission_action",
    },
    {
      label: tableCopy.actions.delete,
      handleClick: handleDelete,
      status: IStatus.error,
      dataTestId: "delete_invitation_action",
    },
  ];

  return actions;
};
